import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Nav, Collapse } from 'reactstrap';
import { Link } from "react-router-dom";
import moment from "moment";

import * as dateTime from "../../helpers/dateTime";
import AppointmentMenuHead from "./AppointmentMenuHead";
import AppointmentShareHistoryItem from "./AppointmentShareHistoryItem";
import ToggleSwitch from "../common/inputv2/ToggleSwitch";
import ShowMoreOrLess from "../common/ShowMoreOrLess";
import { formatDoctorName, getCsnId } from "../../helpers/formatting";
import * as types from "../../constants/actionTypes";
import { setRoomStatus } from "../../api/instaDocBFFApi";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

let audioPlayed = [];
let timer = null;
let timeDiff = null;

function AppointmentList({
    appointments, sameDayCare, setAppointment, setActiveSleekMenu, setShowShareVideoVisitModal, setLinkToReSend, setLinkToCancel, // <-- coming as arguments from the parent component
    serverData, instaDocToken, roomStatuses, providerAppointments, sameDayCareAppointments, employeeRole, // <-- mapStateToProps
    shareLinkHistory, smsVideoVisitLink, smsVideoVisitLinkForGuest, emailVideoVisitLink, emailVideoVisitLinkForGuest, // <-- mapStateToProps
    refreshRooms, getShareLinkHistory, setVideoVisitToastrMsg, sendSms, sendEmail // <-- mapDispatchToProps
}) {
    const [activeItem, setActiveItem] = useState(null);
    const [readyForProvider, setReadyForProvider] = useState(false);
    const [updatingStatus, setUpdatingStatus] = useState(false);
    const [expandShareLinkHistory, setExpandShareLinkHistory] = useState(false);
    const [waitTime, setWaitTime] = useState(null);

    const lanId = window.location && window.location.search;
    const isStaff = employeeRole === 'staff';
    const shareLinkHistoryList = shareLinkHistory && shareLinkHistory.list; //&& shareLinkHistory.list.filter(item => item.status !== 'CANCELED');
    const showCancelResendLinks = serverData && serverData.guestLinkEnabled ? true : false;
    let patientWaitTime = null;
    const audio = new Audio("/audio/notify-patient-joining.mp3");
    let audioPlaying = false;
    let patientWasInRoom = {};

    useEffect(() => {
        if (audio) {
            audio.addEventListener('ended', onAudioPlayBackEnd);
        }

        return () => {
            if (audio) {
                audio.removeEventListener('ended', onAudioPlayBackEnd);
            }
            stopTimer();
        };
    }, []);

    const onAudioPlayBackEnd = () => {
        if (audioPlaying) {
            audio.pause();
            audioPlaying = false;
        }
    }

    /* Close Sleek Submenu */
    const closeSleekMenu = () => {
        setActiveSleekMenu('');
    }

    const setTimer = () => {
        timeDiff = null;
        setWaitTime(null);
        if (!timer) {
            timer = setInterval(() => {
                if (timeDiff) {
                    if (timeDiff.seconds < 59) {
                        timeDiff.seconds++;
                    } else if (timeDiff.minutes < 59) {
                        timeDiff.seconds = 0;
                        timeDiff.minutes++;
                    }
                    else {
                        timeDiff.seconds = 0;
                        timeDiff.minutes = 0;
                        timeDiff.hours++;
                    }
                    setWaitTime(getWaitTimeInString(timeDiff));
                    patientWaitTime = timeDiff;
                }
                setActiveItem(setActiveItem);//this.setState({});
            }, 1000);
        }
    }

    const stopTimer = () => {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        timeDiff = null;
        patientWaitTime = null;
        setWaitTime(null);
    }

    const updateStatus = (activeItem, staffOrProviderInRoom) => {
        let appointments = [];
        if (providerAppointments) {
            appointments = appointments.concat(providerAppointments);
        }
        if (sameDayCareAppointments) {
            appointments = appointments.concat(sameDayCareAppointments);
        }
        const filtered = appointments.filter(appt => appt.csnId === activeItem);
        if (filtered.length > 0) {
            const appointment = filtered[0];
            if (employeeRole && employeeRole.toLowerCase() === 'staff') {
                appointment.epicAppointmentDetails.staffInRoom = staffOrProviderInRoom;
            }
            else {
                appointment.epicAppointmentDetails.providerInRoom = staffOrProviderInRoom;
            }
            refreshRooms(appointment);
        }
    }

    /* Toggle Nav Head Accordion */
    const toggleCollapsed = (e, _activeItem) => {
        if (!activeItem || activeItem !== _activeItem) {
            setTimer();
            setActiveItem(_activeItem);
            setReadyForProvider(null);
            setExpandShareLinkHistory(false);
            getShareLinkHistory(_activeItem);
        }
        else {
            stopTimer();
            updateStatus(_activeItem, false);
            setActiveItem('');
            setReadyForProvider(null);
        }
        closeSleekMenu();
        //logUI("UI.Menu." + item.label.replace(/\s+/g, '') + ".Clicked", new Date(), Tools.getURLPath());
    }

    const getWaitTimeInString = (time) => {
        let waitTime = '';
        if (time) {
            if (time.hours) {
                waitTime = time.hours + ' hr ';
            }
            waitTime += time.minutes + ' min ' + time.seconds + ' sec';
        }
        return waitTime;
    }

    const update = (appt) => {
        appt.selected = (activeItem && activeItem.toLowerCase() === appt.csnId) ? true : false;
        appt.readyForProvider = appt.status === 'READY_FOR_PROVIDER';

        if (appt.selected) {
            const diff = appt.apptDateTime && moment(appt.apptDateTime).diff(moment(), 'minutes');
            const minutesShareLinkIsEnabled = serverData && serverData.minutesShareLinkIsEnabled || 30;
            appt.disableShareLink = diff > minutesShareLinkIsEnabled;
            timeDiff = null;
            patientWaitTime = null;
            if (appt.providerInRoom || appt.staffInRoom) {
                appt.waitTime = getWaitTimeInString(patientWaitTime);
            } else {
                appt.waitTime = '-';
                if (appt.patientInRoom) {
                    if (!timeDiff) {
                        timeDiff = dateTime.timeDiff(appt.patientInRoomDateTime, new Date());
                    }
                    if (timeDiff) {
                        appt.waitTime = getWaitTimeInString(timeDiff);
                        patientWaitTime = timeDiff;
                    }
                }               
            }

            if (readyForProvider !== null) {
                appt.readyForProvider = readyForProvider;
            }
        }

        appt.statusUpdated = (appt.status && roomStatuses[appt.status]) || roomStatuses['ROOM_EMPTY'];
        switch (appt.status) {
            case 'PATIENT_IN_ROOM':
            case 'READY_FOR_PROVIDER':
                appt.statusClass = 'appt-active';
                break;
            case 'ROOMING_IN_PROGRESS':
            case 'IN_PROGRESS':
                appt.statusClass = appt.providerInRoom ? 'appt-active' : 'appt-on-hold';
                break;
            default:
                appt.statusClass = '';
        }

        if (!appt.providerInRoom && appt.providerOrStaffWereInRoom) {
            if (appt.patientInRoom) {
                if (patientWaitTime && (patientWaitTime.hours > 0 || patientWaitTime.minutes >= 5)) {
                    appt.statusClass = 'appt-waiting';
                }
                else {
                    appt.statusClass = 'appt-on-hold';
                }
            }
        }

        const csnId = appt && appt.csnId;
        if (csnId) {
            // reset audioPlayed if patient is no more in the room
            if (audioPlayed[csnId] && !appt.patientInRoom) {
                audioPlayed[csnId] = false;
            }

            if (serverData && serverData.playAudioOnPatientJoining && appt.patientInRoom && (!audioPlayed[csnId] ||
                (typeof patientWasInRoom[csnId] !== 'undefined' && !patientWasInRoom[csnId]))) {
                audioPlaying = true;
                try {
                    var promise = audio.play();
                    audioPlayed[csnId] = true;
                    if (promise !== undefined) {
                        promise.then(_ => {
                            //audioPlayed[csnId] is set to true already
                        }).catch(error => {
                            console.log(error);
                            audioPlayed[csnId] = false; // reset audioPlayed[csnId] back to false
                        });
                    }
                }
                catch (e) {
                    console.log(e);
                }
                audioPlaying = false;
            }
            patientWasInRoom[csnId] = appt.patientInRoom || false;
        }
    }

    const updateReadyForProvider = (appt) => {
        const newStatus = appt.readyForProvider ? 'ROOMING_IN_PROGRESS' : 'READY_FOR_PROVIDER';
        setReadyForProvider(!appt.readyForProvider);
        setUpdatingStatus(true);
        setRoomStatus(instaDocToken, appt.csnId, newStatus)
            .then(response => {
                logUI("UI.VideoVisit.ReadyForProvider", new Date(), Tools.getURLPath(), { room: appt.csnId, response });
                setUpdatingStatus(false);
            })
            .catch(error => {
                logUI("UI.VideoVisit.ReadyForProvider.Error", new Date(), Tools.getURLPath(), { room: appt.csnId, error });
                setReadyForProvider(!readyForProvider);
                setUpdatingStatus(false);
            });
    }

    const setToasterMsg = (target, isSuccess) => {
        const currentTime = Tools.dateStringFormat(new Date(), "h:mm A");
        let message = target ? `Link sent to ${target} at ${currentTime}` : `Link sent at ${currentTime}`;
        if (isSuccess) {
            setVideoVisitToastrMsg(message, true);
        }
        else {
            message = target ? `Link failed to ${target} at ${currentTime}` : `Link failed at ${currentTime}`;
            setVideoVisitToastrMsg(message, false);
        }
    }

    const resendLink = (linkInfo) => {
        const roomId = getCsnId(window.location.pathname);
        linkInfo.reSending = true;
        setActiveItem(setActiveItem);//this.setState({});
        if (linkInfo.target.indexOf('@') > -1) {
            sendEmail(roomId, linkInfo.token.participantName, linkInfo.target, linkInfo.token.participantRole, () => {
                if (emailVideoVisitLink && (linkInfo.linkType && linkInfo.linkType.toLowerCase() === "patientlink")) {
                    setToasterMsg(linkInfo.target, emailVideoVisitLink.isSuccess);
                }
                else if (emailVideoVisitLinkForGuest && (linkInfo.linkType && linkInfo.linkType.toLowerCase() === "guestlink")) {
                    setToasterMsg(linkInfo.target, emailVideoVisitLinkForGuest.isSuccess);
                }
                getShareLinkHistory(roomId);
                linkInfo.reSending = false;
            });
        }
        else {
            sendSms(roomId, linkInfo.token.participantName, linkInfo.target, linkInfo.token.participantRole, () => {
                if (smsVideoVisitLink && (linkInfo.linkType && linkInfo.linkType.toLowerCase() === "patientlink")) {
                    setToasterMsg(linkInfo.target, smsVideoVisitLink.isSuccess);
                }
                else if (smsVideoVisitLinkForGuest && (linkInfo.linkType && linkInfo.linkType.toLowerCase() === "guestlink")) {
                    setToasterMsg(linkInfo.target, smsVideoVisitLinkForGuest.isSuccess);
                }
                getShareLinkHistory(roomId);
                linkInfo.reSending = false;
            });
        }
    }

    const onCancelInviteClick = (shareLinkItem) => {
        logUI("UI.Menu.CancelInvite.Clicked", new Date(), Tools.getURLPath(), { emailOrNumber: shareLinkItem.target });
        setLinkToCancel(shareLinkItem);
    }

    const onResendInviteClick = (shareLinkItem, targetId) => {
        logUI("UI.Menu.ResendInvite.Clicked", new Date(), Tools.getURLPath(), { emailOrNumber: shareLinkItem.target });
        const activeStatusList = ['PENDING', 'INVITED', 'GUEST_WAITING_FOR_APPROVAL', 'GUEST_ALLOWED', 'SENT', 'SUCCESS', 'JOINED'];
        if (activeStatusList.indexOf(shareLinkItem.status) > -1) {
            resendLink(shareLinkItem);
        } else {
            setLinkToReSend({ item: shareLinkItem, guestModalTarget: targetId });
        }
    }

    return (
        <Nav vertical>
            {appointments && appointments.length > 0 && appointments.map(
                (appt, index) => {
                    update(appt);
                    const onlineParticipants = appt.onlineParticipants || [];
                    const allGuestsInRoom = onlineParticipants.filter(p => p.participantRole && p.participantRole.toLowerCase() === "guest");
                    return (<li key={index} className={"appt-item-group" + (appt.selected ? " selected-appt" : "")}>
                        <React.Fragment>
                            <Link
                                className={"appt-menu-head " + appt.statusClass}
                                onClick={(e) => toggleCollapsed(e, appt.csnId)}
                                to={{ pathname: (appt.selected ? '' : '/providervideovisit/' + appt.csnId + sameDayCare) + '/', search: lanId }}
                            >
                                <AppointmentMenuHead
                                    appt={appt}
                                />
                            </Link>
                            <Collapse tag="div" isOpen={appt.selected} className="appt-details-container">
                                <div className="appt-dept-name">
                                    {appt.deptName}
                                </div>
                                <div className="appt-room-activity">
                                    <div className="appt-detail-title">Room Activity</div>
                                    <div className={"room-activity__user details-icon-prepend" + (appt.patientInRoom ? " user-in-room" : "")}>
                                        <div className="icon-col"><span className="icon-user" /></div>
                                        <div className="details-col">
                                            Patient: {appt.patientName}
                                        </div>
                                    </div>
                                    <div className={"room-activity__user details-icon-prepend" + (appt.staffInRoom ? " user-in-room" : "")}>
                                        <div className="icon-col"><span className="icon-user" /></div>
                                        <div className="details-col">
                                            Staff: {appt.staffName !== "" ? appt.staffName : "-"}
                                        </div>
                                    </div>
                                    <div className={"room-activity__user details-icon-prepend" + (appt.providerInRoom ? " user-in-room" : "")}>
                                        <div className="icon-col"><span className="icon-user" /></div>
                                        <div className="details-col">
                                            Provider: {formatDoctorName(appt.providerName)}
                                        </div>
                                    </div>
                                    {allGuestsInRoom && allGuestsInRoom.length > 0 && allGuestsInRoom.map((guest, index) =>
                                        guest && <div key={index} className={"room-activity__user details-icon-prepend" + (guest ? " user-in-room" : "")}>
                                            <div className="icon-col"><span className="icon-user" /></div>
                                            <div className="details-col">
                                                Guest: {guest ? guest.participantName : "-"}
                                            </div>
                                        </div>)}
                                </div>
                                {((!sameDayCare && serverData && serverData.enableShareVideoVisitForAmbulatory) || (sameDayCare && serverData && serverData.enableShareVideoVisitForSdc)) &&
                                    <div className="appt-share-visit">
                                        <button className="btn text-btn share-visit-btn"
                                            disabled={appt.disableShareLink}
                                            onClick={() => {
                                                setShowShareVideoVisitModal(true);
                                                setAppointment(appt);
                                            }}
                                        >SHARE VISIT LINK</button>
                                        {shareLinkHistoryList && shareLinkHistoryList.length > 0 &&
                                            <div className="share-link-history-content">
                                                {(shareLinkHistoryList.filter((item, index) => index === 0)).map((item, index) =>
                                                    <AppointmentShareHistoryItem key={index} shareLinkItem={item} showCancelResendLinks={showCancelResendLinks} targetId={`guest-link-btn-${appt.csnId}-${index}`}
                                                        onCancelInviteClick={(shareLinkItem) => { onCancelInviteClick(shareLinkItem) }}
                                                        onResendInviteClick={(shareLinkItem, targetId) => { onResendInviteClick(shareLinkItem, targetId) }}
                                                    />
                                                )}
                                                {shareLinkHistory && shareLinkHistoryList && shareLinkHistoryList.length > 1 &&
                                                    <React.Fragment>
                                                        <div onClick={() => setExpandShareLinkHistory(!expandShareLinkHistory)} className="share-link-icon-sec">
                                                            {expandShareLinkHistory ? <span className="icon-dd-up" /> : <span className="icon-dd" />}
                                                        </div>
                                                        <Collapse isOpen={expandShareLinkHistory}>
                                                            {(shareLinkHistoryList.filter((item, index) => index !== 0)).map((item, index) =>
                                                                <AppointmentShareHistoryItem key={index} showCancelResendLinks={showCancelResendLinks} shareLinkItem={item} targetId={`guest-link-btn-${appt.csnId}-${index}`}
                                                                    onCancelInviteClick={(shareLinkItem) => { onCancelInviteClick(shareLinkItem) }}
                                                                    onResendInviteClick={(shareLinkItem, targetId) => { onResendInviteClick(shareLinkItem, targetId) }}
                                                                />
                                                            )}
                                                        </Collapse>
                                                    </React.Fragment>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                                <div className="appt-dob">
                                    <div className="appt-detail-title">Patient Date of Birth</div>
                                    <div className="appt-detail-text">{appt.patientDOB ? appt.patientDOB : "-"}</div>
                                </div>
                                <div className="appt-wait-time">
                                    <div className="appt-detail-title">Patient Wait Time</div>
                                    <div className="appt-detail-text">{(appt.patientInRoom && !appt.providerInRoom && !appt.staffInRoom && (waitTime || appt.waitTime)) || "-"}</div>
                                </div>
                                <div className="appt-reason">
                                    <div className="appt-detail-title">Reason for Visit</div>
                                    <div className="appt-detail-text">{appt.reasonForVisit
                                        ? <ShowMoreOrLess text={appt.reasonForVisit} minTextLength={65} />
                                        : <span className="no-data-text">No comment</span>
                                    }</div>
                                </div>
                                {isStaff &&
                                    <div className="appt-status-toggle">
                                        <ToggleSwitch placeholder="Ready for Provider" name="readyForProvider"
                                            disabled={updatingStatus || !appt.patientInRoom} checked={appt.readyForProvider}
                                            onChange={() => updateReadyForProvider(appt)}
                                        />
                                    </div>
                                }
                            </Collapse>
                        </React.Fragment>
                    </li>);
                })
            }
        </Nav>
    );
}

const mapStateToProps = state => {
    return {
        providerAppointments: state.epic.providerAppointments,
        sameDayCareAppointments: state.epic.sameDayCareAppointments,
        serverData: state.session.serverData,
        instaDocToken: state.domain.idt,
        employeeRole: state.domain.er,
        roomStatuses: state.portal.roomStatuses,
        shareLinkHistory: state.videoVisit.shareLinkHistory,
        smsVideoVisitLink: state.videoVisit.smsVideoVisitLink,
        smsVideoVisitLinkForGuest: state.videoVisit.smsVideoVisitLinkForGuest,
        emailVideoVisitLink: state.videoVisit.emailVideoVisitLink,
        emailVideoVisitLinkForGuest: state.videoVisit.emailVideoVisitLinkForGuest,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        refreshRooms: (data) => dispatch({ type: types.APPOINTMENTS_REFRESH_DATA, data }),
        getShareLinkHistory: (room) => dispatch({ type: types.VIDEO_VISIT_SHARE_LINK_HISTORY, room }),
        setVideoVisitToastrMsg: (message, successStatus) => dispatch({ type: types.SET_VIDEO_VISIT_TOASTR_MSG, message, successStatus }),
        sendSms: (room, participantName, mobileNumber, participantRole, callback) => {
            if (participantRole && participantRole.toLowerCase() === 'patient') {
                dispatch({ type: types.SMS_VIDEO_VISIT_LINK, room, mobileNumber, participantName: participantName, callback });
            }
            else {
                dispatch({ type: types.SMS_VIDEO_VISIT_LINK_FOR_GUEST, room, guestName: participantName, mobileNumber, callback });
            }
        },
        sendEmail: (room, participantName, email, participantRole, callback) => {
            if (participantRole && participantRole.toLowerCase() === 'patient') {
                dispatch({ type: types.EMAIL_VIDEO_VISIT_LINK, room, email, participantName: participantName, callback });
            }
            else {
                dispatch({ type: types.EMAIL_VIDEO_VISIT_LINK_FOR_GUEST, room, guestName: participantName, email, callback });
            }
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentList);